module.exports = __webpack_public_path__ + "assets/img/NPC031.abe7647c.png";